
<div class="template1 site">
    <app-header (toggleFromHeader)="toggleFunction()"></app-header>
    <div id="body">
        <app-navbar></app-navbar>
    </div>
    <app-footer></app-footer>
</div>